import React from "react";
import { Routes, Route } from "react-router-dom";
import AdminLayout from "../Admin/components/AdminLayout";
import Dashboard from "../Admin/pages/Dashboard";
import TransportRoute from "../Admin/pages/TransportRoute";
import Settings from "../Admin/pages/Settings";
import SchoolInfo from "../Admin/pages/SchoolInfo";
import Students from "../Admin/pages/Students";
import Session from "../Admin/pages/Session";
import Class from "../Admin/pages/Class";
import Section from "../Admin/pages/Section";
import Group from "../Admin/pages/Group";
import House from "../Admin/pages/House";
import FeeSetup from "../Admin/pages/FeeSetup";
import ClassFee from "../Admin/pages/ClassFee";
import GroupFee from "../Admin/pages/GroupFee";
import StudentTransport from "../Admin/pages/StudentTransport";
import StudentHostel from "../Admin/pages/StudentHostel";
import User from "../Admin/pages/User";
import FCOutStanding from "../Admin/pages/FCOutStanding";
import StudentGroupWise from "../Admin/pages/StudentGroupWise";
import FeeCollection from "../Admin/pages/FeeCollection";
import FCPayModeWise from "../Admin/pages/FCPayModeWise";
import CollectFees from "../Admin/pages/CollectFees";
import UnsettledFees from "../Admin/pages/UnsettledFees";
import ChangePassword from "../Admin/pages/ChangePassword";
import ClassFeeForm from "../Admin/pages/ClassFeeForm";
import GroupFeeForm from "../Admin/pages/GroupFeeForm";
import PayMode from "../Admin/pages/PayMode";
import PayModeForm from "../Admin/pages/PayModeForm";
import StudentsForm from "../Admin/pages/StudentsForm";
import StudentsView from "../Admin/pages/StudentsView";


const AdminRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<AdminLayout />}>

                {/* Default Dashboard */}
                <Route index element={<Dashboard />} />

                {/* All Admin Pages */}
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="schoolinfo" element={< SchoolInfo />} />
                <Route path="students" element={<Students />} />
                <Route path="students/add" element={<StudentsForm />} />
                <Route path="students/edit/:id" element={<StudentsForm />} />
                <Route path="students/view/:id" element={<StudentsView />} />
                <Route path="session" element={< Session />} />
                <Route path="class" element={< Class />} />
                <Route path="section" element={< Section />} />
                <Route path="group" element={< Group />} />
                <Route path="house" element={< House />} />
                <Route path="feesetup" element={< FeeSetup />} />
                <Route path="transportroute" element={< TransportRoute />} />
                <Route path="studenttransport" element={< StudentTransport />} />
                <Route path="studenthostel" element={< StudentHostel />} />
                <Route path="studentgroupwise" element={< StudentGroupWise />} />
                <Route path="feecollection" element={< FeeCollection />} />
                <Route path="fcpaymode" element={< FCPayModeWise />} />
                <Route path="fcoutstanding" element={< FCOutStanding />} />
                <Route path="collectfees" element={< CollectFees />} />
                <Route path="unsettledfees" element={< UnsettledFees />} />
                <Route path="user" element={< User />} />
                <Route path="settings" element={< Settings />} />
                <Route path="changepassword" element={< ChangePassword />} />
                <Route path="classfee" element={<ClassFee />} />
                <Route path="classfee/add" element={<ClassFeeForm />} />
                <Route path="classfee/edit/:id" element={<ClassFeeForm />} />
                <Route path="groupfee" element={< GroupFee />} />
                <Route path="groupfee/add" element={<GroupFeeForm />} />
                <Route path="groupfee/edit/:id" element={<GroupFeeForm />} />
                <Route path="paymode" element={< PayMode />} />
                <Route path="paymode/add" element={<PayModeForm />} />
                <Route path="paymode/edit/:id" element={<PayModeForm />} />

            </Route>
        </Routes>
    );
};

export default AdminRoutes;